module.exports = __webpack_public_path__ + "static/media/file-archive.5680150a.svg";